






























import Icon from './Icon.vue';
import { Component, Vue, Emit } from 'vue-property-decorator';

@Component({
  components: {
    Icon,
  },
})
export default class Modal extends Vue {
  @Emit()
  close() {
    return true;
  }
}
